module.exports = __webpack_public_path__ + "img/d20.87bae5cc.png";